// extracted by mini-css-extract-plugin
module.exports = {"cursor":"PasswordResetForm_cursor__1_qbL","root":"PasswordResetForm_root__O8IFm","password":"PasswordResetForm_password__aBKKE"};